<template>
  <div class="accordion-item">
    <div class="accordion-item__header" @click="toggleAccordion()">
      <div class="accordion-item__header-title">
        {{ title }}
      </div>
      <div>
        <div class="accordion-item__badge">
          <slot name="accordion-badge"></slot>
        </div>
        <z-icon
          :icon="['far', 'chevron-down']"
          :class="{ 'accordion-item__header-icon--rotated': isOpen }"
          class="accordion-item__header-icon"
        />
      </div>
    </div>
    <div class="accordion-item__content" :class="{ 'accordion-item__content--open': isOpen }">
      <div class="accordion-item__inner-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@quero/zilla-core/src/atoms/z-text';

.accordion-item:not(:last-child) {
  border-bottom: 2px solid var(--color-neutral-lighter-gray);
}

.accordion-item__header {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding-bottom: var(--space-large);
  padding-top: var(--space-large);
}

.accordion-item__badge {
  display: inline;
  margin-right: var(--space-medium);
  vertical-align: text-top;
}

.accordion-item__header-title {
  @extend .z-text;

  font-weight: var(--font-weight-bold);
}

.accordion-item__header-icon {
  color: var(--color-primary);
  transition: transform 0.2s ease-in;
}

.accordion-item__header-icon--rotated {
  transform: rotate(180deg);
  transition: transform 0.2s ease-in-out;
}

.accordion-item__content {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out, opacity 0.2s;
}

.accordion-item__content--open {
  max-height: 100vh;
  opacity: 1;
  transition: max-height 0.4s ease-in, opacity 0.4s ease-in;
}

.accordion-item__inner-content {
  padding-bottom: var(--space-large);
}
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
  },
  mounted() {
    this.isOpen = this.open;
  },
};
</script>
